export default {
  getPortfolioProjects(state) {
    return state.portfolioProjects;
  },
  getThreeRecentProjects(state) {
    return state.portfolioProjects.slice(0, 3);
  },
};
